import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    webBlink: webStyle({
        animationIterationCount: "infinite",
        animationTimingFunction: "step-end",
        animationKeyframes: {
            "0%": {
                opacity: 0
            },
            "50%": {
                opacity: 1
            }
        }
    }),
    container: {
        alignSelf: "flex-start"
    }
});

export const useStyles = ({
    blinkDuration
}: {
    blinkDuration: number;
}) => {
    const styles = {
        webBlink: webStyle({
            animationDuration: `${blinkDuration}ms`
        }) as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
